import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import saveAs from 'file-saver';
import { MenuItem } from 'primeng/api';
import { first } from 'rxjs';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { ReportsService } from 'src/app/services/reports.service';

@Component({
  selector: 'app-mi-consolidated-completed-count-wise-report',
  templateUrl: './mi-consolidated-completed-count-wise-report.component.html',
  styleUrls: ['./mi-consolidated-completed-count-wise-report.component.scss']
})
export class MiConsolidatedCompletedCountWiseReportComponent implements OnInit {
  @Input() finyear: string;
  
  @ViewChild('dataTable') tableContainer: ElementRef;

  public subActionType: string = "CompletedApps";
  // public finYear: any;
  vendorCode:any;
  userType:any;
  public miTableData: any = [];
  public actionTypesFromTableData: any = [];
  public miCompletedFilterList: any = [];
  public subscriptions: any = [];
  public userId: any;
  // public selectedMICompletedFilter: null;


  public miTableDataWithFilter: any = [];
  public tableHeaderName = 'Completed Apps';
  miCompletedReport: MenuItem[];
  loading: boolean;

  constructor(
    private reportsService: ReportsService,
    private router: Router,
    private cryptoJsService: CryptoJsService
  ) { }

  ngOnInit(): void {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    this.vendorCode=JSON.parse(sessionToken).officeCode;

    this.userType=JSON.parse(sessionToken).role;
    
    this.loadMIDataUnderProcess(this.subActionType, 0);
    setTimeout( () => this.tableContainer.nativeElement.scrollIntoView({
      block: "center",
      behavior: "smooth"
    }), 400)
    

    this.miCompletedReport = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel(this.miTableDataWithFilter, `MI_${this.tableHeaderName}`);
        },
      },
    ];
  }
  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'APP ID': d.AppID,
          'District': d?.District,
          'Block': d?.Block,
          'Village': d?.Village,
          'Current Level': d.Level_ID,
          'Current Action': d.ActionType,
          'Last Action Date': d.assigneddate,
          'Status': d.Status,
          'Pending Level': d.nextuser,
          'Pending Action': d.NextAction,
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  loadMIDataUnderProcess(subActionType, autoId) {
    // this.loader.start();
    if (autoId == 0) {
      this.loading = true;
    }
    let sub = this.reportsService
      .getMIAggTabsUnProcessedAppsDrillDownNewVendor(this.finyear, subActionType,this.vendorCode,this.userType, autoId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loading = false;
          if (data?.length > 0) {
            this.miTableData = this.miTableData.concat(data);
            this.miTableDataWithFilter = this.miTableData;
            this.actionTypesFromTableData, this.miCompletedFilterList = this.getUniqueActionType(this.miTableData);

            const lastAutoId = data[data.length - 1].AutoId;
            this.loadMIDataUnderProcess(this.subActionType, lastAutoId);

          }else{
            if(autoId ==0){
              this.miTableData = [];
              this.miTableDataWithFilter = [];
              this.actionTypesFromTableData = [];
            }else{
              
            }
            
          }
        },
        error: (err) => {
          // this.loading = false;
          this.loading = false;
          this.miTableData = [];
          this.miTableDataWithFilter = [];
          this.actionTypesFromTableData = [];
        },
      });

      this.subscriptions.push(sub);
  }
  getUniqueActionType(data) {
    const actionLevelSet = new Set(data.map(entry => entry.nextuser));
    const actionLevelObjects = Array.from(actionLevelSet).map(actionLevel => ({ actionLevel }));
    
    return actionLevelObjects;
  }
  printForm(AppID) {
    
    if (AppID) {
      let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
      let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
      this.userId = JSON.parse(payload)?.sub;
      if(this.userId == 'admin'){
        this.router.navigate(['admin', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(AppID.toString()) } });
        // this.router.navigate(['admin', 'print', this.cryptoJsService.Encrypt(AppID)]);
        
      }else if(this.userId == 'CAO'){
        this.router.navigate(['cao', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(AppID.toString()) } });
        // this.router.navigate(['cao', 'print', this.cryptoJsService.Encrypt(AppID)]);
        
      }else if(this.userId == 'DD-EW'){
        this.router.navigate(['ew-department', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(AppID.toString()) } });
        // this.router.navigate(['ew-department', 'print', this.cryptoJsService.Encrypt(AppID)]);
        
      }else if(this.userId== 'Vendor'){
        this.router.navigate(['vendor', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(AppID.toString()) } });
        // this.router.navigate(['vendor', 'print', this.cryptoJsService.Encrypt(AppID)]);
        
      }else if(this.userId== 'webadmin'){
        this.router.navigate(['webadmin', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(AppID.toString()) } });
        // this.router.navigate(['vendor', 'print', this.cryptoJsService.Encrypt(appId)]);
        // const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print', this.cryptoJsService.Encrypt(appId)]));
        // window.open(link, '_blank');
      }else {
        this.router.navigate(['department', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(AppID.toString()) } });
        // this.router.navigate(['department', 'print', this.cryptoJsService.Encrypt(AppID)]);
        
      }
    }
  }

  // onSelectMIConsFilter(){
  //   if(this.selectedMICompletedFilter != null){
  //     this.miTableDataWithFilter = this.miTableData.filter(item => item.nextuser === this.selectedMICompletedFilter?.actionLevel);
  //   }else{
  //     this.miTableDataWithFilter = this.miTableData;
  //   }
  // }

}
